import { render } from "./ShiftSetting.vue?vue&type=template&id=24291784&scoped=true"
import script from "./ShiftSetting.vue?vue&type=script&lang=js"
export * from "./ShiftSetting.vue?vue&type=script&lang=js"

import "./ShiftSetting.vue?vue&type=style&index=0&id=24291784&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24291784"]])

export default __exports__